import "./BillingGeneralTable.scss"
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import Table from "components/Table"
import { COLUMNS } from "./BillingTableColumns"
import { getAllInvoices, getInvoiceSearchResult } from "core/services/api"
import { useSelector } from "react-redux"
import { useHistory } from "react-router"
import DatePicker from "react-datepicker"

function BillingGeneralTable() {
  const [selectedItem, updateSelectedItem] = useState<any>(new Date());
  const [data, setData] = useState([])
  const [debouncedSearchValue, setDebouncedSearchValue] = useState('');
  const userDetail = useSelector((state: any) => state?.user?.userDetail);
  const [searchValue, setSearchValue] = useState('');
  const userRole = useSelector((state: any) => state?.user?.userDetail?.roles[0]);
  const handleSearchChange = (event: any) => {
    const value = event.target.value;
    setSearchValue(value.trimStart());
    console.log(value, "value");
  };

  useEffect(() => {
    if (moment().format("YYYY-MM-DD")) {
      updateSelectedItem(moment().format("YYYY-MM-DD"));
    }
  }, [])

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (searchValue.length > 0) {
        getInvoiceSearchResult(debouncedSearchValue, userDetail?.currentCenter?.centerId)
          .then((res) => {
            console.log(res, "res from API");
            setData(res);
          })
          .catch((err) => {
            console.log("err", err);
          });
      } else {
        getAllInvoices(`${userDetail?.currentCenter?.centerId}`, selectedItem, userRole)
          .then((res) => {
            setData(res);
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
    }, 500);

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [debouncedSearchValue?.trim(), selectedItem]);


  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 500);

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [searchValue]);

  function onPrev() {
    const temp = moment(selectedItem).subtract(1, "days")
    updateSelectedItem(moment(temp).format("YYYY-MM-DD"))
  }

  function onNext() {
    const temp = moment(selectedItem).add(1, "days")
    updateSelectedItem(moment(temp).format("YYYY-MM-DD"))

  }
  const history = useHistory()
  function redirectTo(path: any) {

    history.push(`/invoices/${path}`)
  }

  const [datePickerIsOpen, toggleDatePicker] = useState<any>()
  function handleChange(date: any) {
    let temp = moment(date).format("YYYY-MM-DD")
    toggleDatePicker(!datePickerIsOpen)
    updateSelectedItem(temp)
  }

  return (
    <div className='Billing-general-table-wrapper'>
      <section className="calender-picker-wrapper">
        <div className="Heading">Billing</div>
        <div className="calender-picker">
          <img
            className="iconButtonCal"
            alt="left arrow"
            src="../../assets/images/carouselLeftIcon.svg"
            onClick={() => onPrev()}
          />
          <div className="date-selected">{moment(selectedItem).format("DD MMMM, dddd")}</div>
          <img
            className="iconButtonCal"
            alt="right arrow"
            src="../../assets/images/carouselRightIcon.svg"
            onClick={() => onNext()}
          />

          <DatePicker
            showMonthDropdown={true}
            selected={selectedItem ? new Date(selectedItem) : new Date()}
            onChange={(event: any) => handleChange(event)}
            onClickOutside={() => toggleDatePicker(!datePickerIsOpen)}
            open={datePickerIsOpen}
          />
          <img
            className="iconButtonCals"
            alt="datepicker icon"
            src="../../assets/images/datepickerIcon.svg"
            onClick={() => toggleDatePicker(!datePickerIsOpen)}
          />

        </div>
      </section>
        <div>
          <input
            className="inputGlobalSearch"
            type="text" value={searchValue} onChange={handleSearchChange} placeholder="Search..." />
          <img
            src="../../assets/images/searchIcon.svg"
            alt=""
            style={{ marginLeft: "-50px", width: "26px", height: "26px" }}
          />
        </div>
      {/* Table section */}
      <section>
        <Table
          data={data}
          columns={COLUMNS}
          globalFilterRequired={false}
          onRowClick={(id: any) => redirectTo(id)}
        //onColClick={() => null}
        />
      </section>

    </div>
  )
}

export default BillingGeneralTable